/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ProductCodeValue} from './ProductCodeValue';
import {CommercePrice} from './CommercePrice';
import {Marker} from './Marker';

export interface ProductCart {
  id: number;
  header: string;
  articul: string;
  syncUid: string;
  price: number;
  commercePrice: CommercePrice;
  unitHeader: string;
  picture: string;
  manufacturerHeader: string;
  brandHeader: string;
  manufacturerSeriesHeader: string;
  codes?: ProductCodeValue[];
  // stocks: Stock[];
  multiplicityOrder: number;
  markers: Marker[];
  supplyTerm: number;
}
